import { StandardEvents } from '@shopify/events';

class ProductUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartLinesUpdate);
  }

  disconnectedCallback() {
    this.removeEventListener(StandardEvents.cartLinesUpdate, this.#handleCartLinesUpdate);
  }

  #handleCartLinesUpdate = (event) => {
    if (!(event.target instanceof Element)) return;

    const productForm = event.target.closest('.product-upsell__product-form');
    const button = productForm?.querySelector('.product-upsell__add-button');
    if (!(productForm instanceof HTMLElement) || !(button instanceof HTMLButtonElement) || !this.contains(productForm)) {
      return;
    }

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    const resetButton = () => {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.removeAttribute('data-added');
    };

    if (event.promise) {
      event.promise.then(resetButton).catch(resetButton);
    } else {
      resetButton();
    }
  };
}

if (!customElements.get('product-upsell')) {
  customElements.define('product-upsell', ProductUpsell);
}
